export const STAGE_BADGES = {
  IDENTIFIED: "bg-blue-50 text-blue-600 dark:bg-blue-500/10 dark:text-blue-400",

  QUOTATION: "bg-cyan-50 text-cyan-600 dark:bg-cyan-500/10 dark:text-cyan-400",

  CONTRACT:
    "bg-green-50 text-green-600 dark:bg-green-500/10 dark:text-green-400",

  BA: "bg-yellow-50 text-yellow-600 dark:bg-yellow-500/10 dark:text-yellow-400",

  INVOICE:
    "bg-orange-50 text-orange-600 dark:bg-orange-500/10 dark:text-orange-400",

  PAYMENT: "bg-red-50 text-red-600 dark:bg-red-500/10 dark:text-red-400",

  CLOSED: "bg-gray-100 text-gray-600 dark:bg-gray-500/10 dark:text-gray-400",
};

export const STAGE_LABELS = {
  IDENTIFIED: "Identified",
  QUOTATION: "Quotation",
  CONTRACT: "Contract",
  BA: "BA",
  INVOICE: "Invoice",
  PAYMENT: "Payment",
  CLOSED: "Closed",
};

export const WORK_TYPE_BADGES = {
  TENDER: "bg-pink-50 text-pink-600 dark:bg-pink-500/10 dark:text-pink-400",

  MAINTENANCE:
    "bg-purple-50 text-purple-600 dark:bg-purple-500/10 dark:text-purple-400",
};

export const WORK_TYPE_LABELS = {
  TENDER: "Tender",
  MAINTENANCE: "Non Tender",
};

export const HEALTH_STATUS_BADGES = {
  COMPLETED:
    "border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-500/30 dark:bg-blue-500/10 dark:text-blue-400",

  ON_TRACK:
    "border-green-200 bg-green-50 text-green-700 dark:border-green-500/30 dark:bg-green-500/10 dark:text-green-400",

  DUE_SOON:
    "border-orange-200 bg-orange-50 text-orange-700 dark:border-orange-500/30 dark:bg-orange-500/10 dark:text-orange-400",

  EXPIRED:
    "border-red-200 bg-red-50 text-red-700 dark:border-red-500/30 dark:bg-red-500/10 dark:text-red-400",

  NO_DATE:
    "border-gray-200 bg-gray-50 text-gray-600 dark:border-gray-500/30 dark:bg-gray-500/10 dark:text-gray-400",
};

export const HEALTH_STATUS_LABELS = {
  COMPLETED: "Completed",
  ON_TRACK: "On Track",
  DUE_SOON: "Due Soon",
  EXPIRED: "Expired",
  NO_DATE: "No Date",
};
